var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-width" }, [
    _c(
      "div",
      {
        staticClass: "go-add-collapse collapse show",
        attrs: { id: "go-add-selected" },
      },
      [
        _c("div", { staticClass: "go-slide-wrap" }, [
          _c("div", { staticClass: "go-slide-area" }, [
            _c(
              "ul",
              { staticClass: "go-card-sub-list go-card-resource-selected" },
              _vm._l(
                _vm.getAddingReferenceDocuments.slice(
                  _vm.startIndex,
                  _vm.endIndex
                ),
                function (model, index) {
                  return _c("li", { key: index, staticClass: "go-list-item" }, [
                    _c("div", { staticClass: "go-card-sub" }, [
                      _c("div", { staticClass: "go-card-body" }, [
                        _c(
                          "div",
                          {
                            staticClass: "go-card-title",
                            staticStyle: { "min-height": "21px" },
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(model.title || "Card Title") +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "go-card-desc",
                            staticStyle: { "min-height": "21px" },
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(model.description || "") +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-card-info" }, [
                          _c("span", { staticClass: "go-add-type" }, [
                            _vm._v(_vm._s(model.channel || "")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-icon go-btn-close",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.removeReferenceDocument(model)
                              },
                            },
                          },
                          [_c("i", { staticClass: "go-icon-16 go-icon-close" })]
                        ),
                      ]),
                    ]),
                  ])
                }
              ),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "go-slide-side go-slide-nav-side-left",
              class: {
                disabled:
                  _vm.startIndex === 0 ||
                  _vm.getAddingReferenceDocuments.length < 4,
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn go-slide-nav go-slide-nav-prev",
                  on: { click: _vm.prevSlide },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-chevron-left" })]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "go-slide-side go-slide-nav-side-right",
              class: {
                disabled:
                  _vm.endIndex === _vm.getAddingReferenceDocuments.length + 1 ||
                  _vm.getAddingReferenceDocuments.length < 4,
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "btn go-slide-nav go-slide-nav-prev",
                  on: { click: _vm.nextSlide },
                },
                [_c("i", { staticClass: "go-icon-20 go-icon-chevron-right" })]
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer-inner" }, [
      _c("div", { staticClass: "go-select-info" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("popupAddReference.footer.firstSelectedItemCountText")
              )
          ),
          _c("strong", { staticClass: "go-count" }, [
            _vm._v(_vm._s(_vm.getAddingReferenceDocuments.length)),
          ]),
          _vm._v(
            _vm._s(
              _vm.$t("popupAddReference.footer.secondSelectedItemCountText")
            ) + "\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn go-btn-icon go-btn-close",
            attrs: { type: "button" },
            on: { click: _vm.resetAddingReferenceDocuments },
          },
          [
            _c("span", { staticClass: "go-tooltip-area" }, [
              _c("i", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "go-icon-18 go-icon-close",
                attrs: { title: _vm.$t("popupAddReference.footer.tooltip") },
              }),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-elements" }, [
        _c(
          "button",
          {
            staticClass: "btn go-btn-primary",
            attrs: {
              type: "button",
              disabled:
                !_vm.getAddingReferenceDocuments.length || _vm.isLoading,
            },
            on: { click: _vm.addToReferenceDocuments },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("popupAddReference.footer.buttonAddTitle")) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn go-btn-collapse",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#go-add-selected",
        },
      },
      [_c("i", { staticClass: "go-icon-20 go-icon-chevron-down" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }